import MapUtils from 'qwc2/utils/MapUtils';

/**
 * Returns the min/max resolution of a layer derived from its min/max scale.
 * Uses the projection of the map view, not the data projection of the layer.
 */
export default {
    getResolutionRange(options, map) {
        const projection = map.getView().getProjection().getCode();
        const toResolution = scale => typeof scale === 'number' ? MapUtils.getResolutionsForScales([scale], projection)[0] : undefined;
        return {
            minResolution: toResolution(options.minScale),
            maxResolution: toResolution(options.maxScale)
        };
    }
};
